import { AccountFilterCriteriaProperty, IAccountFilterCriteria } from '../../../../viewmodels/AdminViewModels';
import { FilterOperator } from '../../../../viewmodels/AppViewModels';
import { BillingCycle, IWebsiteCriteria } from './filterOptions';

interface IBillingCycleCriteriaArgs {
	billingCycleFilter: BillingCycle[];
	criteria: IAccountFilterCriteria[];
}

export const appendBillingCycleCriteria = ({ billingCycleFilter, criteria }: IBillingCycleCriteriaArgs) => {
	if (billingCycleFilter.find(x => x === BillingCycle.All) == null) {
		criteria.push({
			criteria: [
				billingCycleFilter.findIndex(x => x === BillingCycle.Monthly) > -1
					? {
							property: AccountFilterCriteriaProperty.BillingCycle,
							value: '1',
						}
					: {},
				billingCycleFilter.findIndex(x => x === BillingCycle.Quarterly) > -1
					? {
							property: AccountFilterCriteriaProperty.BillingCycle,
							value: '3',
						}
					: {},
				billingCycleFilter.findIndex(x => x === BillingCycle.Semiaunnual) > -1
					? {
							property: AccountFilterCriteriaProperty.BillingCycle,
							value: '6',
						}
					: {},
				billingCycleFilter.findIndex(x => x === BillingCycle.Annual) > -1
					? {
							property: AccountFilterCriteriaProperty.BillingCycle,
							value: '12',
						}
					: {},
			],
			op: FilterOperator.Or,
		});
	}
};

interface IWebsiteCriteraArgs {
	websiteFilter: IWebsiteCriteria;
	criteria: IAccountFilterCriteria[];
}

export const appendWebsiteCriteria = ({ websiteFilter, criteria }: IWebsiteCriteraArgs) => {
	if (websiteFilter.value !== null) {
		const websiteCriteria = {
			property: AccountFilterCriteriaProperty.Websites,
			value: websiteFilter.value.toString(),
		};

		criteria.push(websiteCriteria);
	}
};
